import React from "react";
import LoadingComponent from "../components/LoadingComponent";
import styles from "./../ProSession/components/SessionForm/SessionForm.module.css";
const LoadingButtonComponent = ({ loading = false, title = 'title', loadingTitle = "Loading...", children, ...props }) => {
    return (

        <button {...props}  style={{padding:"10px",fontSize:"12px",textTransform: "capitalize!important"}}
                                className={styles.saveBtn}>
            <div className="d-flex">
                {loading ? (
                    <>
                        <LoadingComponent spineerStyle={{ height: '16px', width: '16px', color: '#fff!important', marginTop: '3px' }} />
                        <span className="ps-2">{loadingTitle}</span>
                    </>
                ) : (
                    <>
                        {children}
                        <span style={{textTransform: "capitalize"}} className={children &&'ps-2'}>{title}</span>
                    </>
                )}
            </div>
        </button>
    );
};

export default React.memo(LoadingButtonComponent);
